module.exports = __webpack_public_path__ + "img/mockup.89950889.png";